<app-page-template
  [showHeader]="showTopBar() && !!(sessionService.session$ | async)"
  [class.budgets-android]="device.isAndroidApp"
  [class.budgets-ios]="device.isIosApp"
>
  <router-outlet />
</app-page-template>
<app-ui-toast />
